import * as React from "react";

function SvgDownLeft(props) {
  return <svg data-name="Calque 1" viewBox="0 0 26.69 15.49" width="1em" height="1em" {...props}><path d="M25.94 6.88c1.23.72.89 1.93-.69 2.37L3.66 15.33a3.88 3.88 0 01-2.91-.28c-.72-.41-1-1-.5-1.68L10.67.83c.76-.91 2.84-1.12 4.09-.4l5.57 3.23z" fill="#153042" /></svg>;
}

export default SvgDownLeft;